import React, {useMemo, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {languages, t} from "../common/LocalizationProvider";
import NotificationsMenu from "./NotificationsMenu";
import {languageActions, toggleTheme} from "../store";
import ConfirmHandler from "./ConfirmHandler";
import { cyberStyles } from '../cssShared/cyberTheme';

import {
    FormControl,
    List,
    ListItem,
    ListItemIcon,
    makeStyles, Select,
} from "@material-ui/core";

import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import DashboardIcon from "@material-ui/icons/Dashboard";
import DescriptionIcon from "@material-ui/icons/Description";
import SettingsIcon from "@material-ui/icons/Settings";
import MoreIcon from "@material-ui/icons/MoreVert";
import MenuItem from "@material-ui/core/MenuItem";
import {NightsStay, Translate, WbSunny} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Menu from "@material-ui/core/Menu";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";


const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
}));

const ButtonsHistoryMobile = ({ setDevicesList }) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation()

    const user = useSelector(state => state.session.user);
    const notifications = useSelector(state => Object.values(state.notifications.notifications));
    const languageSelected = useSelector(state => state.language.language);

    const [mobileMenuOpen, setMobileMenuOpen] = useState(null);
    const [notificationsAnchor, setNotificationsAnchor] = useState(null);
    const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

    const userId = user?.id;
    const unseenNotificationCount = useMemo(() => notifications.filter(n => n.unseen).length, [notifications]);


    const handleSetDevicesList = () => {
        if (setDevicesList) setDevicesList(true);
        else history.push('/');
    }

    const isSelected = (item) => {
        if (item?.path === '/') {
            return location.pathname === '/';
        }
        return item.aliases?.some(alias => location.pathname.startsWith(alias));
    }

    const navItems = [
        { icon: <DirectionsCarIcon />, label: t('deviceTitle') ,aliases: ['/'], path: '/', action: handleSetDevicesList },
        { icon: <DashboardIcon />, label: t('dashboardTitle'), aliases: ['/dashboard', '/admin/statistics'], action: () => history.push('/dashboard') },
        { icon: <DescriptionIcon />, label: t('reportTitle'), aliases: ['/reports'],action: () => history.push('/reports/route') },
        { icon: <SettingsIcon />, label: t('settingsTitle'), aliases: ['/user', '/geofences', '/settings', '/admin/users'], action: () => history.push(`/user/${userId}`) },
        { icon: <MoreIcon />, label: t('more'), aliases: [], action: (e) => setMobileMenuOpen(e.currentTarget) },
    ];
    const isDark = useSelector(state => state.theme.mode)

    const renderMenu =
        <Menu
            anchorEl={mobileMenuOpen}
            open={Boolean(mobileMenuOpen)}
            onClose={() => setMobileMenuOpen(null)}
            className={classes.mobileMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
            <MenuItem>
                <IconButton color="inherit" disabled>
                    <Translate className={classes.iconMenuItemColor} />
                </IconButton>
                <FormControl variant="filled" fullWidth size="small" className={classes.formControl}>
                    <Select
                    value={languageSelected || 'en'}
                    onChange={(e) => dispatch(languageActions.updateLanguage(e.target.value))}
                    className={classes.languageSelect}
                    disableUnderline
                    displayEmpty
                    IconComponent={ExpandMoreIcon} // Optional: Add a dropdown arrow for clarity
                    MenuProps={{
                        anchorOrigin: { vertical: "bottom", horizontal: "left" },
                        transformOrigin: { vertical: "top", horizontal: "left" },
                        getContentAnchorEl: null,
                        PaperProps: { className: classes.periodMenuPaper },
                    }}
                >
                    {languages.map((it) => (
                        <MenuItem key={it.code} value={it.code}>
                            {it.name}
                        </MenuItem>
                    ))}
                </Select>
                </FormControl>
            </MenuItem>
            <MenuItem onClick={(event) => setNotificationsAnchor(event.currentTarget)}>
                <IconButton color="inherit">
                    <Badge badgeContent={unseenNotificationCount} className={classes.badge} overlap="rectangular">
                        <NotificationsIcon className={classes.iconMenuItemColor}/>
                    </Badge>
                </IconButton>
                <p>{t("sharedNotifications")}</p>
            </MenuItem>
            <MenuItem onClick={() => setLogoutDialogOpen(true)}>
                <IconButton color="inherit">
                    <ExitToAppIcon className={classes.iconMenuItemColor}/>
                </IconButton>
                <p>{t("exit")}</p>
            </MenuItem>
            <MenuItem onClick={() => dispatch(toggleTheme())}>
                <IconButton color="inherit">
                    {isDark === 'dark' ? <WbSunny className={classes.iconMenuItemColor}/> : <NightsStay className={classes.iconMenuItemColor}/>}
                </IconButton>
                <p>{isDark === 'dark' ? t('lightMode') : t('darkMode')}</p>
            </MenuItem>
        </Menu>

    return (
        <>
            <List className={classes.mobileContainer}>
                {navItems.map((item, index) => (
                    <ListItem
                        button
                        key={index}
                        onClick={item.action}
                        selected={isSelected(item)}
                        classes={{
                            root: classes.mobileItem,
                            selected: classes.selected
                        }}
                    >
                        <ListItemIcon className={classes.iconMobile}>{item.icon}</ListItemIcon>
                        <span className={classes.textMobile}>{item.label}</span>
                    </ListItem>
                ))}
            </List>
                {renderMenu}
                <NotificationsMenu
                    openNotsList={notificationsAnchor}
                    onClose={() =>  setNotificationsAnchor(null)}
                    notifications={notifications}
                />
            <ConfirmHandler open={logoutDialogOpen} endpoint="exit" handleCloseDialog={() => setLogoutDialogOpen(false)}/>
        </>
    );
}

export default ButtonsHistoryMobile;